import { apiClient } from './client';
import { rankingsSchema } from './rankings-contract';

export const rankingsApi = {
  async top(period: 'all' | 'week') {
    const response = rankingsSchema.parse(await apiClient.users.getTopRankings({ period, limit: 100 }));
    if (response.period !== period) throw new Error('Unexpected ranking period');
    return response.data.map((player) => ({
      login: player.login,
      profileName: player.profileName ?? undefined,
      avatarUrl: player.avatarUrl ?? undefined,
      frameUrl: player.selectedFrameUrl,
      frameId: player.selectedFrameId,
      place: player.place,
      score: player.exp,
      level: player.level ?? undefined,
      totalExp: player.totalExp ?? undefined,
    }));
  },
};
